import { useTranslation } from 'react-i18next';
import FadeIn from './FadeIn';
import Card from './Card';

export default function About() {
  const { t } = useTranslation('home');

  const stats = [
    {
      label: t('about.stats.communities.label'),
      value: t('about.stats.communities.value'),
    },
    {
      label: t('about.stats.services.label'),
      value: t('about.stats.services.value'),
    },
    {
      label: t('about.stats.focus.label'),
      value: t('about.stats.focus.value'),
    },
  ];

  const descriptions = t('about.description', { returnObjects: true }) as string[];

  return (
    <section id="about" className="section-padding bg-white">
      <div className="container-custom">
        <div className="max-w-5xl mx-auto">
          {/* Section Header */}
          <FadeIn>
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-neutral-900 mb-4">
                {t('about.title')}
              </h2>
              <p className="text-xl bg-gradient-to-r from-primary-600 to-accent-600 bg-clip-text text-transparent font-semibold">
                {t('about.subtitle')}
              </p>
            </div>
          </FadeIn>

          {/* Mission & Vision */}
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <FadeIn delay={100}>
              <Card hover className="border-l-4 border-primary-500 bg-gradient-to-br from-white to-primary-50">
                <h3 className="text-xl font-semibold bg-gradient-to-r from-primary-600 to-primary-700 bg-clip-text text-transparent mb-3">Mission</h3>
                <p className="text-neutral-700">
                  {t('about.mission')}
                </p>
              </Card>
            </FadeIn>
            <FadeIn delay={200}>
              <Card hover className="border-l-4 border-secondary-500 bg-gradient-to-br from-white to-secondary-50">
                <h3 className="text-xl font-semibold bg-gradient-to-r from-secondary-600 to-secondary-700 bg-clip-text text-transparent mb-3">Vision</h3>
                <p className="text-neutral-700">
                  {t('about.vision')}
                </p>
              </Card>
            </FadeIn>
          </div>

          {/* Description */}
          <FadeIn delay={300}>
            <div className="space-y-4 mb-12">
              {descriptions.map((paragraph, index) => (
                <p key={index} className="text-neutral-700 leading-relaxed">
                  {paragraph}
                </p>
              ))}
            </div>
          </FadeIn>

          {/* Stats */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {stats.map((stat, index) => (
              <FadeIn key={index} delay={400 + index * 100}>
                <div className="text-center p-6 bg-gradient-to-br from-primary-100 via-white to-accent-100 rounded-xl border border-primary-200 shadow-md hover:shadow-xl transition-all transform hover:scale-105">
                  <div className="text-4xl font-bold bg-gradient-to-r from-primary-600 to-accent-600 bg-clip-text text-transparent mb-2">
                    {stat.value}
                  </div>
                  <div className="text-sm text-neutral-700 font-semibold">
                    {stat.label}
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
